export default "__VITE_ASSET__ZON_RpZ9__"